/*
  Vemorina — lazy autoplay voor sectie-video's (performance-traject 2026-07-21).

  WAAROM: een letterlijk `autoplay`-attribuut dwingt de browser om de volledige
  mp4 te downloaden bij paginalading, ook als de video onder de vouw staat
  (2,6 MB op de homepage = de LCP-doodsteek op mobiel 4G). Secties renderen
  daarom `data-vm-video-autoplay` in plaats van `autoplay`; dit script start de
  video pas zodra hij bijna in beeld komt. Voor de bezoeker identiek gedrag:
  de video speelt (loop) op het moment dat hij hem kan zien.

  Samenspel met snippets/vm-video-toggle.liquid: wij spelen elke video maar
  één keer automatisch af (daarna unobserve); pauzeert de bezoeker handmatig,
  dan starten wij hem nooit opnieuw.
*/
(function () {
  'use strict';

  function init() {
    var vids = document.querySelectorAll('video[data-vm-video-autoplay]');
    if (!vids.length) return;

    function start(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* autoplay-block: poster blijft staan, toggle werkt */ });
    }

    if (!('IntersectionObserver' in window)) {
      vids.forEach(start);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        start(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
